import { Asset as RNAsset } from 'react-native-image-picker';
import { Asset } from './UploadImages.types';

export const isNativeAsset = (asset: Asset): asset is RNAsset =>
  'uri' in asset && 'fileName' in asset;

export const formatFormDataImage = (asset: Asset): Blob => {
  if (isNativeAsset(asset)) {
    const { uri = '', type = '', fileName = '' } = asset;

    return { uri, type, name: fileName } as never;
  }

  return asset;
};
